export default __webpack_public_path__ + "static/media/sample.a0f50b2d.svg";